import { Injectable, Renderer2, effect, inject, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoadingComponent } from '@shared/components/loading/loading.component';

@Injectable({
 providedIn: 'root',
})
export class ModalService {
 dialog = inject(MatDialog);

 loadingTemplate: any = LoadingComponent;
 loading: any;
 isAnyModalOpen = signal(false);

 constructor() {}

 showModal(modalTemplate: any, data: any, actionAfterClose: (result: any) => void) {
  const dialogRef = this.dialog.open(modalTemplate, {
   panelClass: [
    'gallery-modal',
    'w-screen',
    'lg:w-[60%]',
    'h-screen',
    '!max-w-full',
    'lg:h-[75vh]',
    'custom-modal',
   ],
   data: data,
   autoFocus: false,
  });

  // // this.renderer.setStyle(this.parentElement, 'position', 'relative');
  // this.loading = this.loadingTemplate.createEmbeddedView({}).rootNodes[0];
  //   // const top = this.parentElement.offsetTop - this.popup.offsetHeight;
  //   // const right = this.parentElement.clientWidth - this.popup.clientWidth
  //   // this.renderer.setStyle(this.popup, 'top', `40%`);
  //   // this.renderer.setStyle(this.popup, 'right', `50%`);
  //   // this.renderer.setStyle(this.popup, 'transform', `translate(-50%, -50%)`);

  // // this.popup.innerHTML = `<div class="flex justify-center items-center text-sm ${this.contentClass}">${this.content}</div>`
  //   this.Renderer2.setStyle(this.loading, 'position', 'absolute');
  //   this.renderer.setStyle(this.loading, 'font-family', 'var(--font-fa)');
  //   // this.renderer.setStyle(this.loading, 'width', `${this.width}px`);
  //   // this.renderer.setStyle(this.loading, 'height', `${this.height}px`);
  //   this.renderer.setAttribute(this.loading, "class", "bg-white rounded-xl shadow-md !z-50 p-4 border-[1px] after:!-z-10 border-gray-200 after:w-5 after:h-5 after:rotate-45 after:bg-white after:absolute after:-bottom-2 after:right-[45%] after:rounded-md mb-20 text-center")
  //   this.renderer.appendChild(document.body, this.loading);

  // dialogRef.afterClosed().subscribe(result => {
  //   actionAfterClose(result)
  // });
  // }

  // closeModal() {
  // }
 }
}
